/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./layout/header"
import Footer from "./layout/footer"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header
        menu={Quick}
        siteTitle={data.site.siteMetadata?.title || `Title`}
      />
      <main className="bg-gray-100">{children}</main>
      <Footer
        menu={Quick}
        service={Service}
        siteTitle={data.site.siteMetadata?.title || `Title`}
      />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const Quick = [
  { title: "Home", to: "/" },
  {
    title: "Properties",
    // to: "/property/",
    drop: [
      {
        title: "For Sale",
        to: "/property/for-sale",
      },
      {
        title: "New Developments",
        to: "/property/new-developments",
      },
      // {
      //   title: "Colombia",
      //   to: "/property/colombia/",
      // },
      {
        title: "Hotels",
        to: "/property/hotels-on-sale/",
      },
      {
        title: "Buyers",
        to: "/buyers/buy-with-us",
      },
      {
        title: "Sellers",
        to: "/sellers/list-with-us",
      },
    ],
  },
  {
    title: "Where to Stay",
    // to: "/buyers/buy-with-us/",
    drop: [
      {
        title: "Villas",
        to: "/rentals/",
      },
      {
        title: "Hotels",
        to: "/where-to-stay/hotels/",
      },
    ],
  },

  { title: "Concierge", to: "/concierge" },
  { title: "Events", to: "/#/" },
  {
    title: "In the Media",
    href: "https://www.youtube.com/channel/UCMcgcfQXRbMuSD_CUkx-glQ",
  },
  {
    title: "About Us",
    // to: "/about",
    drop: [
      {
        title: "The Orchid Group Properties",
        to: "/about/the-orchid-group-properties/",
      },
      {
        title: "Founder",
        to: "/about/founder/",
      },
    ],
  },
  // { title: "Blog", to: "/blog/" },
  { title: "Contact", to: "/contact/" },
]

const Service = [
  { title: "Summer Villas", to: "/rentals/" },
  { title: "Buy Rentals", to: "/buyers/buy-with-us" },
  { title: "Sell Properties", to: "/sellers/list-with-us" },
]
